var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomClipArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 261,
    viewBox: "0 0 210 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_1009",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 263,
    height: 262
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262 -4.57488e-05L0.347656 0L0.347702 261.295L262 261.295L262 -4.57488e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.174 28.7425C131.174 12.8684 118.288 -2.06213e-05 102.392 -1.7842e-05L29.1294 -5.03237e-06C13.2337 -2.25307e-06 0.347658 12.8684 0.347661 28.7425L0.347674 102.845C0.347677 118.719 13.2337 131.587 29.1295 131.587L102.392 131.587C118.288 131.587 131.174 144.456 131.174 160.329L131.174 232.553C131.174 248.427 144.06 261.295 159.956 261.295L233.218 261.295C249.114 261.295 262 248.426 262 232.553L262 158.449C262 142.576 249.114 129.708 233.218 129.708L159.956 129.708C144.06 129.708 131.174 116.839 131.174 100.965L131.174 28.7425Z",
    fill: "url(#paint0_linear_14_1009)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_1009",
    x1: 175.661,
    y1: -15.1859,
    x2: 269.811,
    y2: 326.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714963,
    stopColor: "#1D68F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60EFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomClipArt);
export default __webpack_public_path__ + "static/media/bottom-clip-art.f523038a9752ba2d11e8f9555be33e1e.svg";
export { ForwardRef as ReactComponent };